import { gql } from "@apollo/client";

export const THERAPEUTIC_AREAS = gql`
  query TherapeuticAreas @cache(seconds: 1800) {
    therapeuticAreas {
      name
      slug
    }
  }
`;
